import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const getCompanyBySiret = async (siret) => {
    try {
        if (!siret || siret.length !== 14) {
            throw new Error('Le SIRET doit contenir exactement 14 chiffres');
        }

        // Récupérer le token d'authentification
        const authData = JSON.parse(localStorage.getItem('pocketbase_auth') || '{}');
        const token = authData.token || localStorage.getItem('token');

        const response = await axios.get(`${API_BASE_URL}/api/company/siret/${siret}`, {
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        });

        if (response.data.success && response.data.data) {
            return response.data.data;
        } else {
            throw new Error(response.data.error || 'Aucune donnée trouvée pour ce SIRET');
        }

    } catch (error) {
        console.error('Erreur lors de la récupération des informations SIRET:', error);
        
        if (error.response) {
            // Erreur de réponse du serveur
            const errorMessage = error.response.data?.error || error.response.data?.message || 'Erreur du serveur';
            throw new Error(errorMessage);
        } else if (error.request) {
            // Erreur de réseau
            throw new Error('Erreur de connexion au serveur. Veuillez réessayer.');
        } else {
            // Autres erreurs
            throw new Error(error.message || 'Une erreur inattendue est survenue');
        }
    }
};